import { MARQUEE } from "./content";

const Row = ({ hidden }) => (
  <div className="flex shrink-0 items-center" aria-hidden={hidden}>
    {MARQUEE.map((t) => (
      <span key={t} className="flex items-center font-display italic text-3xl sm:text-5xl text-cream whitespace-nowrap px-6 sm:px-10">
        {t}
        <svg viewBox="0 0 20 20" className="w-5 h-5 sm:w-7 sm:h-7 ml-12 sm:ml-20 text-butter"><path fill="currentColor" d="M10 0c1 6 4 9 10 10-6 1-9 4-10 10-1-6-4-9-10-10 6-1 9-4 10-10z" /></svg>
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section data-testid="editorial-marquee" className="bg-sage py-8 sm:py-10 overflow-hidden -rotate-1 scale-[1.02]">
    <div className="flex w-max animate-marquee">
      <Row />
      <Row hidden />
    </div>
  </section>
);
